import React, { MutableRefObject } from 'react';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import AiMagicIcon from '@grnhse/seedling/lib/birch/icons/ai_magic';
import { withLocalePrefix } from 'shared/utils/translation';
import AiKeywordsList from './ai_keywords_list';
import { PageName } from '../shared/types';
import Api from 'talent_search/lib/api';
import Container from '@grnhse/seedling/lib/birch/components/container';
import styled from 'styled-components';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';

interface Props {
  isLoading: boolean;
  error: string | null;
  displayedKeywords: Array<string>;
  hasKeywords: boolean;
  onAddItem: (keyword: string) => void;
  onAddAll: () => void;
  onRemoveAll: () => void;
  regenerateKeywords?: () => void;
  showRegenerateButton?: boolean;
  pageName: PageName;
  popperRef: MutableRefObject<HTMLElement | null>;
  apiClient?: Api;
  setAiKeywords?: (keywords: string[]) => void;
}

const StyledContainer = styled(Container)`
  border-radius: 0 0 5px 5px;
  margin-top: -1px;
  padding: 8px 16px;
`;

export default function AiKeywordsForm(props: Props) {
  const t = withLocalePrefix(`talent_${props.pageName}.form.sections.keywords`);
  const showLabel = props.hasKeywords && props.displayedKeywords.length > 0;

  return (
    <StyledContainer filled>
      {showLabel && (
        <Stack sx={{ display: 'inline-block' }}>
          <Tooltip label={t('tooltip')} ariaLabel={t('tooltip')}>
            <Stack spacing={1} direction="row">
              <SecondaryBody>{t('instructions')}</SecondaryBody>
              <AiMagicIcon size="xs" />
            </Stack>
          </Tooltip>
        </Stack>
      )}
      <AiKeywordsList {...props} />
    </StyledContainer>
  );
}
